import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextService } from '@maximizer/core/shared/data-access';
import { OutlookStore } from '@maximizer/outlook/shared/data-access';
import { ifNullOrUndefinedThenEmpty } from '@maximizer/shared/util';

export const authenticationGuard: CanActivateFn = () => {
  const contextService = inject(ContextService);
  const outlookStore = inject(OutlookStore);
  const router = inject(Router);

  const isAuthorized = outlookStore.isAuthorized();
  const hasToken = ifNullOrUndefinedThenEmpty(contextService.token) !== '';
  const hasRefreshToken =
    ifNullOrUndefinedThenEmpty(contextService.refresh_token) !== '';
  const hasApi = ifNullOrUndefinedThenEmpty(contextService.api) !== '';

  if (isAuthorized && hasToken && hasRefreshToken && hasApi) {
    return true;
  } else {
    router.navigate(['/home']);
    return false;
  }
};
